export default "__VITE_ASSET__bcfb7bbf__"